import { createContext, useContext, useState, useMemo } from 'react'

const AnimationContext = createContext();

export function AnimationProvider({ children }) {
  const [Stage_1_Offset, setStage_1_Offset] = useState(0)
  const [Stage_2_Offset, setStage_2_Offset] = useState(0)
  const [Stage_3_Offset, setStage_3_Offset] = useState(0)
  const [leftFairingRotation, setLeftFairingRotation] = useState([0, 0, 0])
  const [rightFairingRotation, setRightFairingRotation] = useState([0, 0, 0])
  const [hdriBlend, setHdriBlend] = useState(0) // 0 = Scene 1, 1 = Scene 2
  const [earthEnvBlend, setEarthEnvBlend] = useState(0) // 0 = studio HDRI, 1 = earth environment
  const [scene3Blend, setScene3Blend] = useState(0) // 0 = Scene 2, 1 = Scene 3
  const [earthRotation, setEarthRotation] = useState([-0.3, 0.0, 1.57]) // Earth HDRI rotation [x, y, z]

  // Memoize the context value to prevent unnecessary re-renders
  const contextValue = useMemo(() => ({
    Stage_1_Offset, setStage_1_Offset,
    Stage_2_Offset, setStage_2_Offset,
    Stage_3_Offset, setStage_3_Offset,
    leftFairingRotation, setLeftFairingRotation,
    rightFairingRotation, setRightFairingRotation,
    hdriBlend, setHdriBlend,
    earthEnvBlend, setEarthEnvBlend,
    scene3Blend, setScene3Blend,
    earthRotation, setEarthRotation
  }), [Stage_1_Offset, Stage_2_Offset, Stage_3_Offset, leftFairingRotation, rightFairingRotation, hdriBlend, earthEnvBlend, scene3Blend, earthRotation])

  return (
    <AnimationContext.Provider value={contextValue}>
      {children}
    </AnimationContext.Provider>
  );
}

export function useAnimation() {
  return useContext(AnimationContext)
}
